'use strict';

import Loader from '../../../_modules/loader/loader';

import { debounce, isFieldEmpty } from './_helper';
import { toaster } from './_material';

let $CustService = $('.customer-service'),
	$InstitutionSelect = $('#filterByInstitution'),
	$suggestions = $('.form--suggestions-institutions'),
	loader = new Loader(),
	_data = [],
	_isInvalid = [],
	formSuggestionHtml  = '',
	formSuggestionTmp = '';

$(() => {
    if (!$CustService.length) {
        return false;
    }

   	//To display list of Institutions
    formSuggestionTmp = doT.template($('#institution-suggestion-hcp-tmp').html());

    $InstitutionSelect.on('keyup', debounce(function(){

    	let $this = $(this),
    		$errorContainer = $(this).parent().siblings('.server-errors__wrap'),
    		dataParams = {'name': $this.val()},
    		obj = {},
    		formSuggestionHtml = '';

    	if(isFieldEmpty($this)){

    		$suggestions.removeClass('active');
    		return false;
    	}

    	loader.fadeIn();
		
		$('body').on('click', '.js-populate-institution', function (e) {
			let $this = $(this),
				$ind = $this.data('name');

			populateInstitution($ind);
			$suggestions.removeClass('active');
		});

    	var encodedParams = jQuery.param(dataParams);
    	$.ajax({
	        url: '/api/institutions?'+encodedParams,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
            headers: { __RequestVerificationToken: $CustService.find('input[name=__RequestVerificationToken').val() },
	        type: 'GET',
	        success: function (data) {

	        	$suggestions.addClass('active');

	        	if (!data.length) {
					//Fade in/out loader, display no results
					loader.fadeOut();
					toaster('No results found.', 'error');			
	                $suggestions.removeClass('active');
	                return false;
	            }

	            for (let i = 0, l = data.length; i < l; i++) {
	                obj = {
	                    "id": data[i].InstitutionId,
	                    "name": data[i].InstitutionName
	                };

	                formSuggestionHtml += formSuggestionTmp(obj);
	            }

	            $('.form--institution-suggested').html(formSuggestionHtml);

	        	loader.fadeOut();

	        },
	        error: function (error) {
	            loader.fadeOut();
	            toaster('No results found.', 'error');
	        }
	    });

    }, 250));
});

let populateInstitution = function (name) {
	
	if (name != null) {
        $('#filterByInstitution')
            .val(name).change()
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    }	
}